export default {"src":"/_next/static/media/order_icon_dart.4303ca29.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};